module.exports = __webpack_public_path__ + "media/dashboard/assets/images/integrations/ai-agent-9d941f170e73ef7665d0e1364f2c2ad7.svg";